@if(loader){
    <app-loader></app-loader>
}

<p-card header=" Receive Purchase Order">
    <div>
        <form [formGroup]="purchaseOrderForm">
            <div class="field text-left">
                <div class="flex justify-content-start">
                    <p-button label="Receive" (click)="receivePO()" icon="pi pi-download" severity="success" size="small"></p-button>

                    <p-button label="Cancel" icon="pi pi-times" severity="danger" size="small" class="p-button-sm ml-2"
                        (click)="Cancel()"></p-button>
                </div>
            </div>


            <div class="grid mt-4">
                <div class="col">
                    <div class="field text-left">
                        <label for="website">Purchase Order Number</label>
                        <div style="display: flex; align-items: center;">
                            <input pInputText placeholder="e.g 307" class="w-full p-inputtext-sm" (blur)="checkPurchaseNumber()"
                                formControlName="purchaseOrderNumber" [readonly]="isEditMode || !manualEntryChecked"
                                [ngClass]="{'ng-invalid ng-dirty': submitted && formControls.purchaseOrderNumber.errors }" />
                        </div>
                        <small *ngIf="submitted && formControls.purchaseOrderNumber.errors" id="name-error"
                            class="text-red-500">Required field.</small>
                        <small *ngIf="submitted && purchaseOrderForm.get('purchaseOrderNumber')?.errors?.['required']"
                            id="name-error" class="text-red-500">Required field.</small>
                        <small *ngIf="purchaseOrderForm.get('purchaseOrderNumber')?.errors?.['pattern']" id="name-error"
                            class="text-red-500">Only numeric characters are allowed.</small>
                    </div>
                    <div class="field text-left mt-4">
                        <label for="Vendor">Vendor</label>
                        <div class="p-inputgroup p-lookup">
                            <input pInputText formControlName="vendorCode" readonly styleClass="w-full p-inputtext-sm"
                                placeholder="Search"
                                [ngClass]="{'ng-invalid ng-dirty': submitted && formControls.vendorCode.errors }" />
                            <!-- <button type="button" pButton pRipple severity="info" icon="pi pi-search"
                                (click)="getVendor()"></button> -->
                        </div>
                        <small *ngIf="submitted && formControls.vendorCode.errors" id="name-error"
                            class="text-red-500">Required field.</small>
                    </div>
                    <div class="field text-left">
                        <label for="address">Address</label>
                        <div class="p-inputgroup p-lookup">
                            <input pInputText placeholder="Address" id="address" readonly formControlName="add"
                                styleClass="w-full" />
                        </div>
                    </div>
                </div>
                <div class="col">
                    <div class="field text-left">
                        <label for="requestedDate">Request Date</label>
                        <div class="p-inputgroup p-lookup">
                            <p-calendar [iconDisplay]="'input'" dateFormat="dd/mm/yy" formControlName="requestedDate" 
                                placeholder="Select Date"
                                [ngClass]="{'ng-invalid ng-dirty': submitted && formControls.requestedDate.errors }"
                                styleClass="w-full"></p-calendar>
                        </div>
                        <small *ngIf="submitted && formControls.requestedDate.errors" id="name-error"
                            class="text-red-500">Required field.</small>
                    </div>
                    <div class="field text-left mt-4">
                        <label for="Warehouse">Unit</label>
                        <p-autoComplete [dropdown]="false" [readonly]="true" formControlName="warehouses"
                            styleClass="w-full" [suggestions]="filtewarehouse"
                            (completeMethod)="filteWarehouse($event)" (onSelect)="SelectedWarehouse($event)"
                            field="warehouseCode" placeholder="Search"
                            [ngClass]="{'ng-invalid ng-dirty': submitted && formControls.warehouses.errors }">
                            <ng-template let-item pTemplate="item">
                                <span>{{item.warehouseCode}} - {{item.warehouseName}}</span>
                            </ng-template>
                        </p-autoComplete>
                        <small *ngIf="submitted && formControls.warehouses.errors" id="name-error"
                            class="text-red-500">Required field.</small>
                    </div>
                    <div class="field text-left">
                        <label for="Department">Department</label>
                        <p-autoComplete [readonly]="true" formControlName="departments"
                            [ngClass]="{'ng-invalid ng-dirty': submitted && formControls.departments.errors }"
                            styleClass="w-full" [suggestions]="filterDepartments"
                            (completeMethod)="filterDepartment($event)" (onSelect)="SelectedDepartment($event)"
                            field="departmentCode" placeholder="Search">
                            <ng-template let-item pTemplate="item">
                                <span>{{item.departmentCode}} - {{item.departmentName}}</span>
                            </ng-template>
                        </p-autoComplete>
                    </div>
                </div>

                <div class="col">

                    <div class="field text-left">
                        <label for="ShipToCustomerCode">Ship To Customer Code</label>
                        <span class="p-fluid">
                            <div style="display: flex;">
                                <p-autoComplete formControlName="ShipToCustomerCode" [readonly]="products.length > 0"
                                    (onSelect)="setShipTo($event)" [suggestions]="ShipTocustomerList"
                                    (completeMethod)="autosearchShiptoCustomer($event)" field="customerCode"
                                    styleClass="w-full"
                                    [ngClass]="{'ng-invalid ng-dirty': submitted && formControls.ShipToCustomerCode.errors }">
                                    <ng-template let-item pTemplate="item">
                                        <span>{{item.customerCode}} - {{item.customerName}}</span>
                                    </ng-template>
                                </p-autoComplete>
                                <button type="button" [disabled]="products.length > 0" pButton pRipple
                                    (click)="openShipToCustomerLookup()" icon="pi pi-search" styleClass="p-button-warn"
                                    style="margin-left: 10px;"></button>
                            </div>
                        </span>
                    </div>


                    <div class="field text-left mt-4">
                        <label for="ShipToCustomer">Ship To Customer Name</label>
                        <input pInputText formControlName="ShipToCustomer" readonly class="w-full p-inputtext-sm" />
                    </div>
    
                    <div class="field text-left">
                        <label for="ShipToCustomerAddress">Address</label>
                        <input pInputText formControlName="ShipToCustomerAddress" class="w-full p-inputtext-sm" />
                    </div>

                </div>

            </div>



        </form>
    </div>
    <div>
        <form [formGroup]="purchaseOrderLineItemForm">
            <p-tabView>
                <p-tabPanel header="Order Lines">

                    <p-table #dt1 [value]="products" responsiveLayout="scroll" class="w-full m-5"
                        styleClass="p-datatable-sm" [paginator]="true" [rows]="5" [rowsPerPageOptions]="[5, 10, 20]"
                        [paginator]="true" [(selection)]="selectedProduct" (onEditComplete)="onReceivePOEnter($event)">
                        <ng-template pTemplate="header">
                            <tr>
                                <th><p-tableHeaderCheckbox></p-tableHeaderCheckbox></th>
                                <th>Ln No</th>
                                <th pSortableColumn="ProductCode">Product Code <p-sortIcon
                                        field="ProductCode"></p-sortIcon>
                                </th>
                                <th>Description </th>
                                <th>UOM </th>
                                <th>Qty </th>
                                <th>Qty <br/>Rec'd </th>
                                <th>Qty <br/>Cancel </th>
                                <th>GST </th>
                                <th>Price </th>
                                <th>Extended Cost</th>
                            </tr>
                        </ng-template>
                        <ng-template pTemplate="body" let-product let-i="rowIndex">
                            <tr>
                                <td>
                                    <p-tableCheckbox [value]="product"></p-tableCheckbox>
                                </td>
                                <td>{{i+1}}</td>
                            
                                <td>{{product.ProductCode}} </td>
                                <td>{{product.ProductDescription}} </td>
                                <td>{{product.Uom}} </td>
                                <td>{{product.POQuantity}} </td>
                                <td [pEditableColumn]="product" pEditableColumnField="ReceivedQuantity">
                                    <p-cellEditor>
                                        <ng-template pTemplate="input">
                                            <input pInputText type="number" min="0" [(ngModel)]="product.ReceivedQuantity"
                                                [ngModelOptions]="{ standalone: true }" />
                                        </ng-template>
                                        <ng-template pTemplate="output">
                                            {{ product.ReceivedQuantity }}
                                        </ng-template>
                                    </p-cellEditor>
                                <td>{{product.GSTRate}} %</td>
                                <td>₹{{product.Cost | number: '1.2-2'}} </td>
                                <td>₹ {{product.ExtendedCost | number: '1.2-2'}} </td>
                            </tr>
                        </ng-template>
                        <ng-template pTemplate="summary">
                            <div class="grid">
                                <div class="col flex flex-column align-items-end">
                                    <div class="field text-left">
                                        CGST : ₹ {{CGSTtotal | number: '1.2-2'}}
                                    </div>
                                    <div class="field text-left">
                                        SGST : ₹ {{SGSTtotal | number: '1.2-2'}}
                                    </div>
                                    <div class="field text-left">
                                        IGST : ₹ {{IGSTtotal | number: '1.2-2'}}
                                    </div>
                                    <div class="field text-left">
                                        Taxable : ₹ {{Taxable | number: '1.2-2'}}
                                    </div>
                                    <div class="field text-left">
                                        <div class="hr-line"></div><br>
                                        Total : ₹ <span>{{orderTotal | number: '1.2-2'}}</span>
                                    </div>
                                </div>
                            </div>
                        </ng-template>
                    </p-table>
                </p-tabPanel>

                <p-tabPanel header="PO Details">

                    <form [formGroup]="purchaseOrderForm">

                        <div class="grid">

                            <div class="col">

                                <div class="field text-left">
                                    <label for="shipviacode">Ship via code</label>
                                    <div class="p-inputgroup p-lookup">
                                        <input pInputText class="w-full p-inputtext-sm" formControlName="shipViaCode" />
                                    </div>
                                </div>

                                <div class="field text-left">
                                    <label for="termsCode">Special Instruction</label>
                                    <div class="p-inputgroup p-lookup">
                                        <textarea 
                                        rows="5"
                                        cols="30" 
                                        pInputTextarea formControlName="specialInstruction">
                                    </textarea>
                                    </div>
                                </div>

                            </div>

                            <div class="col">

                                <div class="field text-left">
                                    <label for="termsCode">Terms Code</label>
                                    <div class="p-inputgroup p-lookup">
                                        <input pInputText class="w-full p-inputtext-sm" formControlName="termsCode" />
                                        <button type="button" pButton pRipple severity="info" icon="pi pi-search"
                                            (click)="getTermsCode()"></button>
                                    </div>
                                </div>

                                
                                <div class="field text-left">
                                    <label for="PurchaseOrderComment">Purchase Order Comment</label>
                                    <div class="p-inputgroup p-lookup">
                                        <textarea 
                                        rows="5"
                                        cols="30" 
                                        pInputTextarea formControlName="purchaseOrderComment">
                                    </textarea>
                                    </div>
                                </div>

                            </div>

                        </div>

                    </form>

                </p-tabPanel>

            </p-tabView>
        </form>
    </div>
</p-card>
<p-toast></p-toast>
<p-confirmDialog></p-confirmDialog>